import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';

import { SupportedLocale, supportedLocaleOptions } from 'framework';

interface LocaleSelectProps {
  ariaLabel: string;
  className?: string;
  fullWidth?: boolean;
  onChange: (locale: SupportedLocale) => Promise<void> | void;
  size?: TextFieldProps['size'];
  value: SupportedLocale;
  variant?: TextFieldProps['variant'];
}

export const LocaleSelect = ({
  ariaLabel,
  className,
  fullWidth,
  onChange,
  size = 'small',
  value,
  variant = 'outlined'
}: LocaleSelectProps) => (
  <TextField
    className={className}
    fullWidth={fullWidth}
    onChange={event => onChange(event.target.value as SupportedLocale)}
    select
    SelectProps={{ native: true }}
    size={size}
    value={value}
    variant={variant}
    inputProps={{ 'aria-label': ariaLabel }}
  >
    {supportedLocaleOptions.map(option => (
      <option key={option.locale} value={option.locale}>
        {option.label}
      </option>
    ))}
  </TextField>
);